import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class UsersService {
    /**
     * Get/search all users
     * @param queryParams {array} Example: [['name':'John']]
     * @returns {Promise<Array>} Array of users
     */
    static async getUsersAsync(queryParams) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/users/list`, queryParams);
        return response || [];
    }

    static async putUserAsync(formData) {
        const response = await NetworkService.putMultiPartAsync(`${API_BASE_URL}/user`, formData);
        return response;
    }

    static async getUserCountersAsync() {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/user/counters`);
        return response;
    }

    static async putUserPreferencesAsync(formData) {
        const response = await NetworkService.putAsync(`${API_BASE_URL}/user/notification-preferences`, formData);
        return response;
    }
}
